import { Flex, Text } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";

export const LinhaTituloValor = ({
  title,
  value,
}: {
  title: string;
  value: number;
}) => (
  <Flex justifyContent="space-between" gap={4} w="100%">
    <Text>{title}</Text>
    <Text fontWeight="bold">{formatMoney(value)}</Text>
  </Flex>
);
